<template>
    <div>
        <h3 class="text-center mt-4 mb-3">{{jsonObjectContact.contactHead}}</h3>
        <p>{{jsonObjectContact.email}}</p>
        
    </div>
</template>

<script>
    import jsonObjectContact from './Contact.json';
export default {
    data(){
        return {
            jsonObjectContact,

        }
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/EN-vers/menu/Contact.vue